export const ADD_LOADING_BAR = 'addLoadingBar'

export default {
  strict: process.env.NODE_ENV === 'production',
  state: {
    loadingBars: {}
  },
  getters: {
    loadingBars: state => state.loadingBars
  },

  mutations: {
    /**
     * 로딩바를 Store에 저장한다.
     * @param {*} state
     * @param {*} loadingBar key는 <BeLoading>의 ref이고 value는 LoadingBar이다.
     */
    [ADD_LOADING_BAR] (state, loadingBar) {
      Object.assign(state.loadingBars, loadingBar)
    }
  },

  actions: {
    /**
     * 로딩바를 Store에 저장한다.
     * @param {*} state
     * @param {*} loadingBar key는 <BeLoading>의 ref이고 value는 LoadingBar이다.
     */
    [ADD_LOADING_BAR] (context, loadingBar) {
      context.commit(ADD_LOADING_BAR, loadingBar)
    }
  }
}
